import { axios, BaseApiUrl } from '../axios_config';


// 获取移动端快速搜索
export const getList = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/GetDeliveryOrderInfo`, { ...params }).then(res => res.data)
}
//复测
export const recheck = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/RecheckSubmit`, { ...params }).then(res => res.data)
}

//托盘
export const editPalletSubmit = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/EditPalletSubmit`, { ...params }).then(res => res.data)
}


